export const CAREER_PROSPECTS_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    icon: "/images/icon.png",
    hover_icon: "/images/hover-icon.png",
    title_text_color: "#000000",
    text: "Sample title text",
    description_text_color: "#666666",
    description: "Sample description text",
    priority: 1,
  },

  CAREER_PROSPECTS_FIELDS_CONFIG: [
    {
      fieldName: "design_variant",
      label: "Design Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select design variant",
      helperText: "Only changes the spacing and font sizes.",
      required: false,
      defaultValue: "variant_1",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
      ],
    },
    {
      fieldName: "title",
      label: "Career Prospects Title",
      value: "Career Prospects",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Career Prospects Title",
      required: false,
      defaultValue: "Career Prospects",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "sub_title",
      label: "Sub Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Sub Title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "sub_title_text_color",
      label: "Sub Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter sub title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "cta_text",
      label: "CTA Text",
      value: "Read More",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA Text",
      required: false,
      defaultValue: "Read More",
    },
    {
      fieldName: "cta_variant",
      label: "View More Button Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select View More button style",
      required: false,
      defaultValue: "variant_1",
      options: [
        { label: "Variant 1 (Filled Button)", value: "variant_1" },
        { label: "Variant 2 (Underlined Link – mobile)", value: "variant_2" },
      ],
    },
    {
      fieldName: "cta_text_color",
      label: "CTA Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "cta_background_color",
      label: "CTA Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_icon",
      label: "CTA Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload CTA Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_icon_alt",
      label: "CTA Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for CTA icon",
      required: false,
      defaultValue: "Read more",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "show_apply_now",
      label: "Show Apply Now Button",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show/Hide Apply Now Button",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "apply_now_text",
      label: "Apply Now Button Text",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Apply Now button text",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "apply_now_text_color",
      label: "Apply Now Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Apply Now text color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "apply_now_background_color",
      label: "Apply Now Background Color",
      value: "#9F1C34",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Apply Now background color (e.g., #9F1C34)",
      required: false,
      defaultValue: "#9F1C34",
    },
    {
      fieldName: "status",
      label: "Career Prospects Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Career Prospects",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Icon",
      fieldName: "icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Icon",
      required: true,
    },
    {
      header: "Icon Alt Text",
      fieldName: "alt_icon",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Text for Icon",
      required: false,
    },
    {
      header: "Hover Icon",
      fieldName: "hover_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Hover Icon",
      required: false,
    },
    {
      header: "Title Text Color",
      fieldName: "title_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Title Text Color",
      required: false,
    },
    {
      header: "Title Text",
      fieldName: "text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title Text",
      required: true,
    },
    {
      header: "Description Text Color",
      fieldName: "description_text_color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Description Text Color",
      required: false,
    },
    {
      header: "Description",
      fieldName: "description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Description",
      required: true,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
  ],
};

